'use client';
import type { NextPage } from 'next';
import { useState } from 'react';
import styles from './type-aircraft-select.module.scss';

interface TypeAircraftSelectProps {
  className?: string;
  label?: string;
  value?: string;
  onChange?: (value: string) => void;
  icon?: string;
}

const TypeAircraftSelect: NextPage<TypeAircraftSelectProps> = ({
  className = '',
  label,
  value = '',
  onChange,
  icon,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const aircraftOptions = [
    { value: 'Light Jet', label: 'Light Jet' },
    { value: 'Mid-Size Jet', label: 'Mid-Size Jet' },
    { value: 'Super Mid-Size Jet', label: 'Super Mid-Size Jet' },
    { value: 'Heavy Jet', label: 'Heavy Jet' },
  ];

  const handleSelect = (optionValue: string) => {
    onChange?.(optionValue);
    setIsOpen(false);
  };

  const selectedOption = aircraftOptions.find(
    (option) => option.value === value
  );
  const displayText = selectedOption?.label || 'Select the type';

  return (
    <div className={[styles.root, className].join(' ')}>
      {label && <label className={styles.label}>{label}</label>}
      <div className={styles.selectContainer}>
        {/* eslint-disable-next-line @next/next/no-img-element */}
        {icon && <img src={icon} alt="" className={styles.inputIcon} />}
        <div className={styles.selectField} onClick={() => setIsOpen(!isOpen)}>
          <span
            className={`${styles.selectText} ${!selectedOption ? styles.placeholder : ''}`}
          >
            {displayText}
          </span>
          <svg
            className={`${styles.chevron} ${isOpen ? styles.chevronOpen : ''}`}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              d="M4 6L8 10L12 6"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        {isOpen && (
          <div className={styles.dropdown}>
            {aircraftOptions.map((option) => (
              <div
                key={option.value}
                className={`${styles.option} ${option.value === value ? styles.selected : ''}`}
                onClick={() => handleSelect(option.value)}
              >
                {option.label}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default TypeAircraftSelect;
